import { Campaign } from '../../../models/campaign';

export const RulesHelper = {
    isValidNumberOfVisuals(count: number): boolean {
        return count >= 1 && count != null;
    },

    isValidNewNumberOfVisuals(count: number | any): boolean {
        if (typeof count === 'number') {
            return count >= 0 && count != null;
        }
        return typeof count !== 'object';
    },

    allValidVisualStatuses(mediasList: any[]): boolean {
        if (!mediasList || mediasList.length === 0) return false;
        
        const validStatuses = mediasList.map(media => {
            const nonPausedMedia = media.subMedias.find(sm => sm.status !== 'PAUSED');
            return !!nonPausedMedia;
        });
        
        return !validStatuses.includes(false);
    },

    isSubMediaComplete(subMedia: any): boolean {
        if (!subMedia.title?.trim()) return false;
        if (!subMedia.asset?.length) return false;
        if (subMedia.asset.some(a => !a.fileName?.trim())) return false;
        
        if (!subMedia.mediaChannels?.length) return false;
        
        return !subMedia.mediaChannels.some(channel => 
            !channel.channelId || !channel.key || !channel.op || channel.value === null || channel.value === ''
        );
    },

    hasAnyIncompleteVisual(mediasList: any[]): boolean {
        for (const media of mediasList) {
            for (const subMedia of media.subMedias) {
                const hasSomeData = !!subMedia.title?.trim() || 
                                    subMedia.asset?.length > 0 || 
                                    subMedia.mediaChannels?.some(c => c.channelId);
                
                const isComplete = this.isSubMediaComplete(subMedia);
                if (hasSomeData && !isComplete) return true;
            }
        }
        return false;
    },

    hasAtLeastOneCompleteVisual(mediasList: any[]): boolean {
        for (const media of mediasList) {
            for (const subMedia of media.subMedias) {
                if (this.isSubMediaComplete(subMedia)) return true;
            }
        }
        return false;
    },

    isMediaListDirty(mediasList: any[]): boolean {
        return mediasList.some(media =>
            media.subMedias.some(subMedia =>
                (subMedia.title && subMedia.title.trim() !== '') ||
                (subMedia.asset && subMedia.asset.length > 0) ||
                (subMedia.mediaChannels && subMedia.mediaChannels.some(c => c.channelId && c.channelId !== ''))
            )
        );
    },

    validateFields(campaign: Campaign, mediasList: any[]): boolean {
        if (!campaign) return true;
        
        for (const campaignChannelId of campaign.channels) {
            let channelFound = false;

            for (const media of mediasList) {
                for (const subMedia of media.subMedias || []) {
                    if (!this.isSubMediaComplete(subMedia)) return false;

                    const coversChannel = subMedia.mediaChannels.some(mc => 
                        mc.channelId === campaignChannelId && mc.key === 'GEN'
                    );
                    
                    if (coversChannel) {
                        channelFound = true;
                        break;
                    }
                }
                if (channelFound) break;
            }

            if (!channelFound) return false;
        }
        return true;
    },

    validateGenericRule(mediasList: any[], resIdx: number, subMediaIdx: number, channelId: string, channelIdx: number, rule: any): boolean {
        const subMedia = mediasList[resIdx].subMedias[subMediaIdx];
        const currentChannelRules = subMedia.mediaChannels.filter(c => c.channelId === channelId);
        
        const genericCount = currentChannelRules.filter(c => c.key === 'GEN' && c.value == -1 && c.op === 'EQ').length;
        const hasOtherRule = currentChannelRules.some(c => !(c.key === 'GEN' && c.value == -1 && c.op === 'EQ') && (c.key || c.value || c.op));
        const isCurrentGeneric = subMedia.mediaChannels[channelIdx].key === 'GEN' && subMedia.mediaChannels[channelIdx].value == -1;

        if (hasOtherRule && genericCount === 1 && mediasList[resIdx].subMedias.length > 1) {
            return isCurrentGeneric;
        } 
        
        if (genericCount === 1 && isCurrentGeneric) return true;
        if (genericCount > 0 && !isCurrentGeneric && rule.key === 'GEN') return false; // Trying to add another generic

        return true;
    },

    validateOnlyOneChannelPerMedia(mediasList: any[], resIdx: number, subMediaIdx: number, channelId: string): boolean {
        const channels = mediasList[resIdx].subMedias[subMediaIdx].mediaChannels;
        return channels.some(c => c.channelId === channelId);
    }
};